<template>
  <div class="mainMenuWrapper"
       v-on:click="goToSelectPage"
       v-bind:style="isSelected ? 'background-color: rgb(0,153,255); color: white;' : ''">
    <img class="iconImg" v-bind:src="iconImg">
    <span>{{spanText}}</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      iconImg: ''
    }
  },
  props: {
    menuKey: String,
    routerName: String,
    spanText: String,
    isSelected: Boolean
  },
  methods: {
    catchRedundant: function (err) {
      if (
        err.name !== 'NavigationDuplicated' &&
        !err.message.includes('Avoided redundant navigation to current location')
      ) {
        console.log(err)
      }
    },
    setIconImg: function () {
      if(this.menuKey === 'mainBoard') {
        this.iconImg = this.isSelected ? require('@/assets/img/main_board_icon_on.png') : require('@/assets/img/main_board_icon_off.png')
      }else if(this.menuKey === 'myAdvertise') {
        this.iconImg = this.isSelected ? require('@/assets/img/my_advertise_icon_on.png') : require('@/assets/img/my_advertise_icon_off.png')
      }else if(this.menuKey === 'profile') {
        this.iconImg = this.isSelected ? require('@/assets/img/profile_icon_on.png') : require('@/assets/img/profile_icon_off.png')
      }
    },
    goToSelectPage: function () {
      this.$router.push({ name: this.routerName }).catch(this.catchRedundant)
    }
  },
  created: function () {
    this.setIconImg()
  },
  watch: {
    isSelected: function () {
      this.setIconImg()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span{
  font-size: 12px;
  font-weight: bold;
}

.mainMenuWrapper{
  cursor: pointer;
  position: relative;
  display: flex;
  display: -ms-flexbox;
  justify-content:left;
  align-items: center;
  margin: 12px 10%;
  height: 40px;
  padding-left: 15px;
  border-radius: 0.3rem;
}

.iconImg {
  width: 24px;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/elements/mainMenu.vue